currentSubscriptionType